import React, { useEffect, useState } from "react";
import {
  Input,
  Space,
  Form,
  Button,
  notification,
  message,
  DatePicker,
} from "antd";
import { AiOutlineRight } from "react-icons/ai";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import policyRequest from "../Policy/PolicyRequest";
import ReactQuill from "react-quill"; // Import ReactQuill
import "react-quill/dist/quill.snow.css"; // Import ReactQuill styles
import dayjs from "dayjs";

export const UpdateTermsCondition = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams(); // Get the id from the URL params
  const [termsConditionData, setTermsConditionData] = useState(null); // Store the fetched terms condition data
  const [content, setContent] = useState(""); // State to manage content for ReactQuill

  const fetchTermsConditionData = () => {
    setLoading(true);
    policyRequest
      .getTermsConditionsById(id) // Assuming you have a method to get the term condition by ID
      .then((response) => {
        const data = response?.data?.data || {};
        console.log(data);
        setTermsConditionData(data); // Save fetched data to state
        setContent(data.content || ""); // Set the content to the editor's state
        form.setFieldsValue({
          ...data, // Populate the form fields with fetched data
          effectiveDate: data.effectiveDate ? dayjs(data.effectiveDate) : null,
        });
      })
      .catch((error) => {
        message.error("Failed to fetch terms condition data");
        console.log("error", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onFinish = (values) => {
    console.log(values);
    setLoading(true);

    // Adding the content to the values before sending to the API
    const updatedValues = { ...values, content };

    policyRequest
      .updateTermsConditions(id, updatedValues) // Assuming you have an API method for updating terms conditions
      .then((res) => {
        if (res.status === 200) {
          notification.success({
            message: "Terms & Condition updated successfully",
          });
          navigate(-1, { state: { refresh: true } }); // Navigate to the previous page
        } else {
          notification.error({
            message: "Something went wrong",
          });
          setLoading(false);
        }
      })
      .catch((e) => {
        setLoading(false);
        notification.error({
          message: "Failed to update Terms & Condition",
        });
        console.error("API Error:", e);
      });
  };

  const handleSubmit = () => {
    form.submit(); // Trigger form validation and submission
  };

  useEffect(() => {
    if (id) {
      fetchTermsConditionData(); // Fetch the terms condition data when editing a terms condition
    }
  }, [id]);

  return (
    <>
      <section>
        <div className="Create-Category">
          <Form.Item className="text-center submit-btn">
            <Space>
              <Button
                className="f-sub-btn btn-width"
                onClick={() => navigate(-1)}
                disabled={loading}
              >
                <ArrowLeftOutlined />
              </Button>
            </Space>
          </Form.Item>
          <h3>Update Terms & Condition</h3>

          {/* Add Ant Design Form component and pass the form instance */}
          <Form form={form} layout="vertical" onFinish={onFinish}>
            <div className="subscription">
              {/* Replaced Input with ReactQuill */}
              <Form.Item
                name="content"
                label="Content"
                className="subscription-plan"
                style={{ width: "100%" }}
                rules={[
                  { required: true, message: "Please enter the content" },
                ]}
              >
                <ReactQuill
                  value={content} // Bind ReactQuill value to the content state
                  onChange={setContent} // Update content state on change
                  placeholder="Enter Content"
                  style={{ height: "300px", width: "100%" }}
                />
              </Form.Item>
            </div>

            <div className="subscription">
              <Form.Item
                name="versionNumber"
                label="Version Number"
                className="subscription-plan"
                rules={[
                  {
                    required: true,
                    message: "Please enter the version number",
                  },
                ]}
              >
                <Input
                  type="number"
                  size="large"
                  placeholder="Enter Version Number"
                />
              </Form.Item>
              <Form.Item
                name="effectiveDate"
                label="Effective Date"
                className="subscription-plan"
                rules={[
                  {
                    required: true,
                    message: "Please select the effective date",
                  },
                ]}
              >
                <DatePicker
                  placeholder="Select Effective Date"
                  style={{ width: "99%" }}
                />
              </Form.Item>
            </div>

            <div className="bottom-button">
              <div style={{ padding: "10px" }}>
                <Button type="primary" htmlType="submit" loading={loading}>
                  Save
                  <span>
                    <AiOutlineRight />
                  </span>
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </section>
    </>
  );
};
